function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".a,.d{fill:#62c3ef;}.a,.b{stroke:#2373d0;}.a,.b,.d,.e,.g,.i,.j,.k,.l,.m,.n,.o,.p{stroke-linecap:round;}.a,.b,.d,.e,.g,.i,.j,.l,.m,.n,.o{stroke-linejoin:round;stroke-miterlimit:10;}.a,.n,.o,.p{stroke-width:3px;}.b{fill:#00bf6f;}.b,.d,.e,.g,.i,.j,.k,.l,.m{stroke-width:2px;}.c{fill:#2373d0;}.d,.e,.g,.i,.j,.k,.l,.m,.o,.p{stroke:#34508b;}.e,.f{fill:#fbf8f3;}.g,.k,.n,.o,.p{fill:none;}.h,.m{fill:#34508b;}.i{fill:#f7ab6f;}.j{fill:#fff;}.l{fill:#dcdee0;}.n{stroke:#f7ab6f;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-536.5 -213.3)"
}, React.createElement("g", {
  transform: "translate(538 214.8)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("g", {
  transform: "translate(170.612 20.272)"
}, React.createElement("circle", {
  className: "a",
  cx: 43.377,
  cy: 43.377,
  r: 43.377
}), React.createElement("path", {
  className: "b",
  d: "M580.8,301.377A43.379,43.379,0,0,0,537.424,258c-.755,0-1.574,0-2.329.063-3.714,6.547-4.974,13.536-7.3,20.587a5.339,5.339,0,0,1,6.107,1.511,5.2,5.2,0,0,1,.126,6.3c-1.7,2.329-4.848,2.833-7.366,4.155a11.96,11.96,0,0,0-5.918,12.906,14.821,14.821,0,0,1,.63,2.9,17.307,17.307,0,0,0,.126,2.581,5.129,5.129,0,0,0,4.722,3.84,10.9,10.9,0,0,0,6.17-1.7c2.518-1.385,5.225-3.274,8.058-2.581,2.455.63,4.407,3.148,6.862,2.77,1.826-.252,2.959-1.952,4.281-3.211s3.589-2.141,4.785-.818a15.2,15.2,0,0,1,2.77,9.821,12.664,12.664,0,0,0,0,3.777,2.863,2.863,0,0,0,2.581,2.329c2.9-.189,2.707-5.855,5.666-6.107,1.574-.126,2.707,1.763,2.518,3.337-.126,1.574-1.07,2.959-1.826,4.407-1.2,2.518-.63,3.966.881,5.981C576.9,323.6,580.8,311.765,580.8,301.377Z",
  transform: "translate(-494.047 -258)"
}), React.createElement("path", {
  className: "c",
  d: "M556.231,274.6A43.352,43.352,0,0,1,523.3,346.182a42.914,42.914,0,0,1-28.2-10.451,43.4,43.4,0,0,0,76.366-28.2A43.605,43.605,0,0,0,556.231,274.6Z",
  transform: "translate(-484.649 -264.149)"
})), React.createElement("g", {
  transform: "translate(23.357 0.63)"
}, React.createElement("path", {
  className: "d",
  d: "M424.341,460.2H255.491A10.9,10.9,0,0,1,244.6,449.309V333.091A10.9,10.9,0,0,1,255.491,322.2H424.341a10.9,10.9,0,0,1,10.891,10.891V449.372A10.882,10.882,0,0,1,424.341,460.2Z",
  transform: "translate(-244.6 -262.139)"
}), React.createElement("path", {
  className: "e",
  d: "M244.6,512.2v4.911a13.515,13.515,0,0,0,13.536,13.536h163.5a13.515,13.515,0,0,0,13.536-13.536V512.2Z",
  transform: "translate(-244.6 -332.522)"
}), React.createElement("g", {
  transform: "translate(9.443 69.441)"
}, React.createElement("rect", {
  className: "f",
  width: 171.745,
  height: 100.793
}), React.createElement("rect", {
  className: "g",
  width: 171.745,
  height: 100.793
})), React.createElement("circle", {
  className: "h",
  cx: 3.903,
  cy: 3.903,
  r: 3.903,
  transform: "translate(91.413 184.966)"
}), React.createElement("g", {
  transform: "translate(30.849 45.329)"
}, React.createElement("rect", {
  className: "i",
  width: 64.467,
  height: 105.074
}), React.createElement("rect", {
  className: "i",
  width: 64.467,
  height: 105.074,
  transform: "translate(64.467)"
})), React.createElement("g", {
  transform: "translate(37.9 40.481)"
}, React.createElement("rect", {
  className: "j",
  width: 57.416,
  height: 104.193
}), React.createElement("rect", {
  className: "j",
  width: 57.416,
  height: 104.193,
  transform: "translate(57.416)"
}), React.createElement("rect", {
  className: "b",
  width: 21.72,
  height: 30.093,
  transform: "translate(9.443 10.325)"
}), React.createElement("line", {
  className: "g",
  x2: 38.152,
  transform: "translate(9.443 52.065)"
}), React.createElement("line", {
  className: "g",
  x2: 38.152,
  transform: "translate(9.443 62.327)"
}), React.createElement("line", {
  className: "g",
  x2: 38.152,
  transform: "translate(9.443 72.589)"
}), React.createElement("line", {
  className: "g",
  x2: 38.152,
  transform: "translate(9.443 82.851)"
})), React.createElement("path", {
  className: "c",
  d: "M445.484,394.8,430.689,293H430.5v66.23L397.7,394.8Z",
  transform: "translate(-301.314 -251.323)"
}), React.createElement("path", {
  className: "j",
  d: "M429.871,336.93,396,373.7V269.5l33.871-36.7Z",
  transform: "translate(-300.684 -229.023)"
}), React.createElement("path", {
  className: "k",
  d: "M0,0H144.3",
  transform: "translate(23.168 150.403)"
}), React.createElement("path", {
  className: "l",
  d: "M317.584,278.312V271.45H314a20.947,20.947,0,0,0-3.526-8.436l2.644-2.644-4.848-4.848-2.644,2.644a21.489,21.489,0,0,0-8.373-3.463v-3.9h-6.862v3.9a20.58,20.58,0,0,0-8.31,3.4l-2.77-2.77-4.848,4.848,2.707,2.707a20.057,20.057,0,0,0-3.526,8.31H269.8v6.862h3.714a20.506,20.506,0,0,0,3.4,8.5l-2.581,2.581,4.848,4.848,2.518-2.518a20.208,20.208,0,0,0,8.5,3.651v3.526H297v-3.463a20.878,20.878,0,0,0,8.625-3.526l2.455,2.455,4.848-4.848-2.455-2.455A20.618,20.618,0,0,0,314,278.249h3.589Zm-10.2-4.722h-9.318a4.67,4.67,0,0,0-3.022-3.022v-9.318A13.869,13.869,0,0,1,307.385,273.59Zm-15.047-12.277v9.318a4.67,4.67,0,0,0-3.022,3.022H280A13.87,13.87,0,0,1,292.338,261.314ZM280.062,276.36h9.318a4.67,4.67,0,0,0,3.022,3.022V288.7A13.812,13.812,0,0,1,280.062,276.36Zm15.047,12.277v-9.318a4.67,4.67,0,0,0,3.022-3.022h9.318A13.812,13.812,0,0,1,295.109,288.637Z",
  transform: "translate(-253.935 -235.69)"
}), React.createElement("path", {
  className: "l",
  d: "M380.771,244.806v-5.666h-3.84a11.758,11.758,0,0,0-1.259-3.211l2.644-2.644-4.029-4.029-2.644,2.644a11.654,11.654,0,0,0-3.274-1.385V226.8H362.7v3.714a11.653,11.653,0,0,0-3.274,1.385l-2.644-2.644-4.029,4.029,2.644,2.644a11.759,11.759,0,0,0-1.259,3.211H350.3v5.666h3.9a12.33,12.33,0,0,0,1.322,3.085l-2.77,2.77,4.029,4.029,2.833-2.833a12.206,12.206,0,0,0,3.085,1.259v4.029h5.666v-4.029a10.979,10.979,0,0,0,3.085-1.259l2.833,2.833,4.029-4.029-2.77-2.77a13.413,13.413,0,0,0,1.322-3.085Zm-15.236.693a3.651,3.651,0,1,1,3.651-3.651A3.614,3.614,0,0,1,365.535,245.5Z",
  transform: "translate(-283.755 -226.8)"
}), React.createElement("path", {
  className: "e",
  d: "M411.03,583.344H338V581.77a6.18,6.18,0,0,1,6.17-6.17h60.753a6.18,6.18,0,0,1,6.17,6.17v1.574Z",
  transform: "translate(-279.199 -356.008)"
}), React.createElement("rect", {
  className: "e",
  width: 33.871,
  height: 21.531,
  transform: "translate(78.381 198.061)"
}), React.createElement("rect", {
  className: "m",
  width: 33.871,
  height: 8.184,
  transform: "translate(78.381 198.061)"
}), React.createElement("line", {
  className: "g",
  x2: 22.601,
  transform: "translate(30.849 161.169)"
}), React.createElement("line", {
  className: "g",
  x2: 11.269,
  transform: "translate(148.514 161.169)"
}), React.createElement("line", {
  className: "g",
  x2: 41.866,
  transform: "translate(85.684 161.169)"
})), React.createElement("g", {
  transform: "translate(0 107.341)"
}, React.createElement("line", {
  className: "n",
  x1: 11.458,
  transform: "translate(0 22.35)"
}), React.createElement("line", {
  className: "n",
  x1: 8.121,
  y1: 8.121,
  transform: "translate(1.7)"
}), React.createElement("line", {
  className: "n",
  y1: 8.121,
  x2: 8.121,
  transform: "translate(1.7 36.578)"
})), React.createElement("g", {
  transform: "translate(241.564)"
}, React.createElement("line", {
  className: "n",
  y1: 8.121,
  x2: 8.121,
  transform: "translate(8.877 14.606)"
}), React.createElement("line", {
  className: "n",
  x2: 11.521,
  transform: "translate(20.083 31.604)"
}), React.createElement("line", {
  className: "n",
  y2: 11.521
})), React.createElement("path", {
  className: "o",
  d: "M578.2,328.7a6.731,6.731,0,0,1,4.911,5.351",
  transform: "translate(-344.82 -263.918)"
}), React.createElement("path", {
  className: "o",
  d: "M550.2,302.64s2.518-4.344,1.007-7.24",
  transform: "translate(-334.448 -251.582)"
}), React.createElement("path", {
  className: "p",
  d: "M0,29.275",
  transform: "translate(176.089 198.691)"
}))));
var SvgMyWork = function SvgMyWork(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 276.169,
    height: 230.466,
    viewBox: "0 0 276.169 230.466",
    ref: svgRef
  }, props), _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMyWork, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/my-work.8421cda6.svg";
export { ForwardRef as ReactComponent };